import React from 'react';
import { Chip } from '@mui/material';

interface ReferralUnreadBadgeProps {
  count: number;
}

const ReferralUnreadBadge: React.FC<ReferralUnreadBadgeProps> = ({ count }) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Chip
      color="primary"
      label={count === 1 ? '1 unread' : `${count} unread`}
      size="small"
      sx={{ fontWeight: 700 }}
    />
  );
};

export default ReferralUnreadBadge;
